export enum AnalysisStatus {
  Complete,
  CompleteWithErrors,
  Pending,
  Running,
  Caching,
  TooFewRecords,
}
